
import { defineComponent, ref } from "vue";
import Swal from "sweetalert2/dist/sweetalert2.js";
import {Actions} from "@/store/enums/StoreEnums";
import {useStore} from "vuex";
import {hideModal} from "@/core/helpers/dom";

export default defineComponent({
  name: "add-user-modal",
  props: ["reloadData"],
  components: {},
  setup(props) {
    const store = useStore();
    const formRef = ref<null | HTMLFormElement>(null);
    const addUserModalRef = ref<null | HTMLElement>(null);
    const loading = ref<boolean>(false);
    const formData = ref({
      name: "",
      email: "",
      role: "User"
    });

    const rules = ref({
      name: [
        {
          required: true,
          message: "User name is required",
          trigger: "change",
        },
      ],
      email: [
        {
          required: true,
          message: "User email is required",
          trigger: "change",
        },
        {
          type: "email",
          message: "User email is invalid",
          trigger: "change",
        },
      ],
      role: [
        {
          required: true,
          message: "User role is required",
          trigger: "change",
        },
      ],
    });

    const submit = () => {
      if (!formRef.value) {
        return;
      }

      formRef.value.validate((valid) => {
        if (valid) {
          loading.value = true;

          setTimeout(() => {
            store
                .dispatch(Actions.ADD_USER, formData.value)
                .then(() => {
                  loading.value = false;
                  props.reloadData()
                  hideModal(addUserModalRef.value);
                })
                .catch(() => {
                  loading.value = false;

                  Swal.fire({
                    text: store.getters.getErrors[0],
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "Try again!",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-danger",
                    },
                  });
                });
          }, 2000);
        } else {
          Swal.fire({
            text: "Sorry, looks like there are some errors detected, please try again.",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          return false;
        }
      });
    };

    return {
      formData,
      rules,
      submit,
      formRef,
      loading,
      addUserModalRef,
    };
  },
});
